<template>
	<v-window v-model="window" touchless>
		<v-window-item>
			<DataBaseView />
		</v-window-item>
		<v-window-item>
			<!-- <DetailedForm /> -->
			<AgentBase />
		</v-window-item>

		<TtFormDialog class="rounded-xl" />
		<CompleteViewTtFormDialog class="rounded-xl" />
		<QueryFormBase class="rounded-xl" />
		<div v-if="ckeckGroupPermission([GROUPS.MASMOVIL])">
			<CoverageView />
			<ResourcesView />
		</div>
		<SpreadSheetDialogOps />
		<PopUpDialog />
		<CoverageAvatelView v-if="ckeckGroupPermission([GROUPS.AVATEL])" />
	</v-window>
</template>

<script>
import TtFormDialog from './TtForm/TtFormDialog.vue';
import CompleteViewTtFormDialog from './TtForm/CompleteViewTtFormDialog.vue';
import QueryFormBase from './QueryForm/QueryFormBase.vue';
import CoverageView from './CoverageView/CoverageView.vue';
import CoverageAvatelView from './CoverageAvatelView/CoverageAvatelView.vue';
import ResourcesView from './Resources/ResourcesView.vue';
import DataBaseView from './DataBaseView/DataBaseView.vue';
import SpreadSheetDialogOps from './SpreadsheetDialog/SpreadSheetDialogOps.vue';
// import DetailedForm from './DetailedView/DetailedForm.vue';
import AgentBase from './Agent/AgentBase.vue';
import PopUpDialog from './TtForm/PopUpDialog.vue';

import { mapState, mapGetters } from 'vuex';

export default {
	name: 'ComercialTeletrabajo',

	components: {
		TtFormDialog,
		CompleteViewTtFormDialog,
		DataBaseView,
		ResourcesView,
		QueryFormBase,
		CoverageView,
		CoverageAvatelView,
		SpreadSheetDialogOps,
		AgentBase,
		// DetailedForm,
		PopUpDialog,
	},
	computed: {
		...mapState('teletrabajo', {
			window: (state) => state.currentView,
		}),
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapGetters('login', {
			isComercialCobOrRec: 'isComercialCobOrRec',
			ckeckGroupPermission: 'ckeckGroupPermission',
			isComercialColaborador: 'isComercialColaborador',
		}),
	},
	created() {
		if (!this.$store.state.util.origenesBBDD) {
			this.$store.dispatch('util/fetchOrigenesBBDD');
		}
		this.$store.dispatch('teletrabajo/fetchComerciales');
	},
};
</script>